import { LandingPage } from '@src/layout/LandingPage';
import { AppContextProvider } from '@src/contexts/AppContextProvider';
import 'ag-grid-community/styles/ag-grid.css'; // Core CSS
import 'ag-grid-community/styles/ag-theme-quartz.css'; // Theme
// Loaded after the ag-grid theme so its --ag-font-family override (App.scss) wins - ag-theme-quartz.css sets the
// same variable at equal specificity, and the later import wins ties.
import '@src/App.scss';

const App = () => {
  return (
    <AppContextProvider>
      <LandingPage />
    </AppContextProvider>
  );
};

export default App;
